import { useFeatureFlag } from '@moda/portal-stanchions';

export const useShoppableEditsFlag = () =>
  useFeatureFlag('show-edits-in-customer-account', [{ default: false }, { if: true, then: true }]);
